// extracted by mini-css-extract-plugin
export default {"section":"SectionCard_section__PiJv9","mainContainer":"SectionCard_mainContainer__AFdpA"};